import React, { useContext, useState } from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { NCRContext } from 'views';

import {
  Replacements,
  Returns,
  ReplacementOrderNumber,
  Warehouse,
  OverheadCost,
  TransportCost,
  InstallationCost,
  TotalCosts,
  CustomerName,
  Address,
  ContactName,
  ContactNumber,
  ShippingInstructions,
  GenerateCSV,
  ImportNetsuite,
  CreateReturn,
  OrderItems,
  OriginalWarehouse, DateRequired, FocFromHQ, FocCustomer, Incoterms,
  ReturnItems, ReturnReason, Condition, Collection, Pallets, BookingSlot, ReturnWarehouse,
  ReturnAddress, ReturnCustomerName, ReturnContactName, ReturnContactNumber, OpeningTimes, 
  ReturnInstructions, ReturnTotalCosts, LogisticCost, ContactEmail, RestockCharge, CreateReturnSandbox, ImportNetsuiteSandbox, GetReturnItems, GetReplacementItems
} from 'components/form/fields';
import { Asterisk } from 'components/form/prototypes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const OrderDetail = () => {

  const { state } = useContext(NCRContext);

  const Link = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <div className="question_mark">{children}</div>
    </OverlayTrigger>
  );

  var ncr_return = 0;
  var booking_slot = null;
  var pallet_return = 0;

  if (state.ncr.return != null) {
    ncr_return = state.ncr.return.returnItems.length
    booking_slot = state.ncr.return.booking_slot
    pallet_return = state.ncr.return.returnPallets.length
  }

  const [replacements, setReplacements] = useState(state.ncr.order.orderItems.length > 0);
  const [returns, setReturns] = useState(ncr_return > 0);
  const [collection, setCollection] = useState(booking_slot != null);
  const [condition, setCondition] = useState(pallet_return < 0)

  return (
    <>
      <Row className={'mb-4'}>
        <Col>
          <Replacements replacements={replacements} setReplacements={setReplacements} />
        </Col>
        <Col />
      </Row>
      {replacements && <>
        <Row className={'mb-2'}>
          <Col>
            <Row className={'mb-2'}>
              <Col><h5>Order Information</h5>
                <hr />
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col md>
                <DateRequired/>
                <FocFromHQ/>
                <FocCustomer/>
                <Incoterms/>
              </Col>
              <Col md>
                <ReplacementOrderNumber />
                <OriginalWarehouse />
                <Warehouse />
              </Col>
            </Row>
            <Row className={'my-4 text-center'}>
              <Col>
                <GetReplacementItems />
              </Col>
            </Row>
            <OrderItems />
            <Row className={'mb-4'}>
              <Col md>
                <OverheadCost />
                <TransportCost />
                <InstallationCost />
              </Col>
              <Col md>
                <TotalCosts />
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col><h6>Delivery &amp; Contact Information</h6>
                <hr />
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col md>
                <CustomerName />
                <Address />
              </Col>
              <Col md>
                <ContactName />
                <ContactNumber />
                <ShippingInstructions />
              </Col>
            </Row>
          {replacements && !returns &&
            <Row className={'my-4 text-center'}>
              <Col>
                <GenerateCSV />
                <ImportNetsuite />
                <ImportNetsuiteSandbox />
              </Col>
            </Row> 
          }
          </Col>
        </Row>
      </>}
      <hr></hr>
      <Row className={'mb-4'}>
        <Col>
          <Returns returns={returns} setReturns={setReturns} />
        </Col>
        <Col>
        </Col>
      </Row>
      {returns && <>
        <Row className={'mb-2'}>
        <Col>
          <Row className={'mb-2'}>
            <Col><h5>Return Information</h5>
              <hr />
              <h6>Please note: There is a 25% restock charge on all Return Orders</h6>
            </Col>
          </Row>
          <Row className={'mb-2'}>
                <Col>
                    <h5>Return Details: {state.ncr.return.number || ''}
                    <hr />
                    </h5>
                </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md>
              <ReturnReason />
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md={6}>
              <Condition condition={condition} setCondition={setCondition}/>
                              
            </Col>
            <Col md={1}>            
            <Link id="t-2" title="Fill in Pallet Details for Returns unless order is in same condition as Despatch Note.">
              ?
            </Link>
            </Col>
            <Col md={5}>
              <ReturnWarehouse />           
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md>             
              <RestockCharge />
            </Col>
            <Col md>
              
            </Col>        
          </Row>
          <Row className={'mb-2'}>
            <Col md>             
              <Collection collection={collection} setCollection={setCollection} />
            </Col>
            {!collection &&
              <Col md>             
                
              </Col>
            }
            {collection &&
              <Col md>
                <Asterisk />
                <BookingSlot />
              </Col>
            }  
          </Row>
          {collection &&
            <Row className={'mb-2'}>
              
              <Col md>
                <OpeningTimes />
              </Col>
            </Row>
          }
          <Row className={'my-4 text-center'}>
            <Col>
              <GetReturnItems />
            </Col>
          </Row>
          <ReturnItems />
          <Pallets />
          <Row className={'mb-4'}>
              <Col md>
                <LogisticCost />                
              </Col>
              <Col md>
                <ReturnTotalCosts />
              </Col>
          </Row>
          {collection && <>
            <Row className={'mb-2'}>
              <Col>
                <h6>Collection Address &amp; Contact Information</h6>
                <hr />
              </Col>
            </Row>
            <Row className={'mb-2'}>
            <Col md>
                <ReturnCustomerName />
                <ReturnAddress />
              </Col>
              <Col md>
                <ReturnContactName />
                <ReturnContactNumber />
                <ContactEmail />
                <ReturnInstructions />
              </Col>
            </Row>   
          </>}
          {!replacements &&
            <Row className={'my-4 text-center'}>
              <Col>
                <CreateReturn />
                <CreateReturnSandbox />
              </Col>
            </Row> 
          }
          {replacements && returns &&
            <Row className={'my-4 text-center'}>
              <Col>
                <GenerateCSV />
                <ImportNetsuite />
                <ImportNetsuiteSandbox />
                <CreateReturn />
                <CreateReturnSandbox />
              </Col>
            </Row> 
          }
                    
        </Col>
        </Row>
      </>}
      <hr></hr>
    </>
  )
}

export { OrderDetail };
